import React, {
    useRef,
    useState
} from 'react';

import RIQModal from '../../../components/RIQModal.jsx';

import RIQButton from '../../../components/RIQButton.jsx';


import useNavigationInterception from '../../../hooks/useNavigationInterception.js';

import {
    useCurationConfigValue,
    useSerializeConfigurations
} from '../../../hooks/widgetConfiguration.js';

import {
    useLoadLandscapeListeningQuery
} from './useListeningQueryPersistence.js';


function UnsavedWorkModal({onCompleteNavigation, onFinishMyWork}) {

    return (
        <RIQModal
            showModal={true}
        >
            <div
                className='tlw-overflow-x-auto tlw-p-25 tlw-text-center'
            >

                <div
                    className='tlw-mb-5 tlw-text-lg tlw-font-semibold'
                >
                    You didn&apos;t save this search.
                </div>
                <p
                    className='tlw-mb-15'
                >
                    Are you sure you want to exit?
                </p>

                <RIQButton
                    className='tlw-mx-4 tlw-px-6 tlw-py-3'
                    onClick={onCompleteNavigation}
                >
                    Yes, exit
                </RIQButton>
                <RIQButton
                    className='tlw-mx-4 tlw-px-6 tlw-py-3'
                    onClick={onFinishMyWork}
                    variant='primary'
                >
                    No, finish my work
                </RIQButton>
            </div>
        </RIQModal>
    );
}

export default function useUnsavedWorkWarning() {
    const navigateFcnRef = useRef();
    const [showingModal, setShowingModal] = useState(false);
    const editingListeningQueryId = useCurationConfigValue('editingListeningQueryId');
    const {data: listeningQuery} = useLoadLandscapeListeningQuery(editingListeningQueryId);

    const onNavigation = useSerializeConfigurations(allProps => {
        let dirty = false;

        const relevantProps = _.omit(allProps, 'editingListeningQueryId', 'wProps', 'name');
        if (editingListeningQueryId) {
            // we're dirty if there's any props/name that don't match listeningQuery

            const wizardName = allProps.name;
            const savedName = listeningQuery.name;

            dirty = wizardName !== savedName || !_.isEqual(relevantProps, listeningQuery.definition);

        } else {
            // we're dirty if there's any props that have been set.
            dirty = !_.isEmpty(relevantProps);
        }

        if (dirty) {
            setShowingModal(true);
        } else {
            navigateFcnRef.current();
        }
    });

    useNavigationInterception(navigateFcn => {
        navigateFcnRef.current = navigateFcn;
        onNavigation();

        // always return false because we don't know if we want to pause the interception yet; onNavigation will take care of proceeding
        // immediately if it needs to.
        return false;
    });

    function onFinishMyWork() {
        setShowingModal(false);
    }

    if (showingModal) {
        return (
            <UnsavedWorkModal
                onCompleteNavigation={navigateFcnRef.current}
                onFinishMyWork={onFinishMyWork}
            />
        );
    }
}
